import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Stack } from '@mui/material';
// import faker from 'faker';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

const VerticalBarChart = (props) => {
	console.log('props=------------>>>', props);
	const options = {
		responsive: true,
		plugins: {
			legend: false,
			title: {
				display: false,
				// text: 'Chart.js Bar Chart',
			},
		},
	};

	const newData = (value) => {
		console.log('value------------>>>', value);
		let final = '';
		if (value?.question_type === 'star') {
			let temp = value?.ratings?.map((val, i) => {
				return val.rating;
			});
			final = temp;
			return final;
		} else if (
			value?.question_type === 'checkbox' ||
			value?.question_type === 'radio'
		) {
			let temp3 = value?.options?.map((val, i) => {
				return val.optionCount;
			});
			final = temp3;
			return final;
		}

		console.log('newdata--------->>>', final);
		return final;
	};
	const newLabel = (value) => {
		let final = '';
		if (value?.question_type === 'star') {
			let temp = value?.ratings?.map((val, i) => {
				return val.star;
			});
			final = temp;
			return final;
		} else if (
			value?.question_type === 'checkbox' ||
			value?.question_type === 'radio'
		) {
			let temp3 = value?.options.map((val, i) => {
				return val.optionName;
			});
			final = temp3;
			return final;
		}
		return final;
	};

	const labels = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
	];

	const data = {
		labels: newLabel(props.data),
		datasets: [
			{
				label: '',
				data: newData(props.data),
				fill: false,
				backgroundColor: [
					'#97DFFC',
					'#8F75FF',
					'#5829A7',
					'#461177',
					'#8EB5F0',
					'#5e4fa2',
					'#3288bd',
					'#9e0142',
					'#d53e4f',
					'#f46d43',
				],
				borderColor: 'rgba(75,192,192,1)',
				pointStyle: 'rectRounded',
				barThickness: 50,
			},
		],
	};
	return (
		<>
			<div>
				<Bar options={options} data={data} height={80} />
			</div>
		</>
	);
};

export default VerticalBarChart;
